

<template>
  <div class="sign-distribution">
    <div class="header">
      <div class="top-box">
        <span class="back-box" @click="back">
          <van-icon size="18px" name="arrow-left" style="vertical-align: sub;" />
          <span class="return-text">返回</span>
        </span>
      </div>
      <!-- <el-radio-group v-model="radio" @change="handleRadioChange" >
        <el-radio label="1">按科室分配</el-radio>
        <el-radio label="2">按人员分配</el-radio>  
      </el-radio-group> -->
    </div>
    <!-- @@ -->
    <section class="signList" v-if='radio==1' ref="signList">
      <div class="block header">
        <span class="name-block">科室</span>
        <span class="input-block">数量</span>
      </div>
      <div class="block" v-for="(item,index) in tableData" :key="index">
        <div class="name-block">
          <p>{{item.deptName}}({{item.totalNum}}人)</p>
        </div>
        <el-input
          class="input-block"
          autofocus
          v-model="item.groupAndNum"
          placeholder="请输入"
          size="mini"
          type="number"
          oninput="value=value.replace(/\D/g,'')"
          @blur="scrollToTop"
        ></el-input>
      </div>
    </section> 
    <!-- @@ -->
    <div class="sino-welfare-footer">
      <div class="footer-tip">提交后不可更换报名类型</div>
      <el-button class="save-btn" @click="submit" :disabled="submitLoading" v-loading="submitLoading">确定</el-button>
    </div>

  </div>
</template>

<script type="text/ecmascript-6">
import { signUpByDept,getBranchByDeptsLeader,getGroupInfoForSignup, delSignup } from "@/common/api";
import { toast } from "@/common/api/api.js";
export default {
  props:['signupInfo','activityId','deptId','signType',"signUpCount",'selectedGroupUnionId','signupStaff',"unionListThree"],
  data() {
    return {
      nums:[],
      // @@
      radio:"1",
      loginInfo:"",
      tableData:[],
      tableDataOrigin:[],
      num:'',
      submitLoading:false
    };
  },
  created() {
    this.loginInfo=JSON.parse(localStorage.getItem("loginInfo"));
    //@@
    // let data={
    //   radio:2
    // };
    // this.$emit('selChange',data);
    //@@
  },
  mounted(){
    // if(this.signType==0&&this.signUpCount>0){
    //   this.radio="2";
    //   this.handleRadioChange();
    // }
    this.getBranchByDeptsLeader();
    this.$refs.signList.scrollTop = 0;
  },
  methods:{
    scrollToTop() {
      setTimeout(() => {
        window.scrollTo(0, document.body.scrollTop + 1);
        document.body.scrollTop >= 1 && window.scrollTo(0, document.body.scrollTop - 1);
      }, 10)
    },
    back(){
      this.$emit("goback");
    },
    handleRadioChange(){
      if(this.radio=="2"){
        let data={
          radio:2
        };
        this.$emit('selChange',data,this.tableDataOrigin);
      }
    },
    // 分会主席获取他的分会下科室和人数限制
    getBranchByDeptsLeader(){
      let {groupId} =this.signupInfo;
      groupId=groupId&&groupId.indexOf('_')>=0?groupId.split('_')[0]:groupId;
      let data={
        unionId:this.selectedGroupUnionId||this.loginInfo.unionId,
        activityId: this.activityId,
        groupId:groupId, // 分组id
      };
      getBranchByDeptsLeader(data).then(res => {
        if(res.code=='200'){
          this.tableDataOrigin=JSON.parse(JSON.stringify(res.data));
          this.tableData=JSON.parse(JSON.stringify(res.data));
          if(!res.data||!res.data.length)this.tableDataOrigin=JSON.parse(JSON.stringify(this.unionListThree));
          if(!res.data||!res.data.length)this.tableData=JSON.parse(JSON.stringify(this.unionListThree));
          setTimeout(()=>{
            this.$refs.signList.scrollTop = 0;
          },1)
        }
      })
    },

    //报名点击确定
    submit(){
      // if(this.radio=='')return toast(this,'请先选择类型','error')
      // if(this.signType==1&&this.signUpCount>0){
      //   toast(this,'分会组长已进行报名,不可修改','error')
      //   return;
      // }else if(this.signType==0&&this.signUpCount>0){
      //   toast(this,'已经进行了按人员分配报名，不能再按科室分配','error')
      //   return;
      // }else{
      //   this.signUpByDept();
      // }
       this.signUpByDept();
    },
    
    // 分会主席按科室报名
    signUpByDept(){
      this.submitLoading=true;
      let totalSignNum=0; // 分配总人数
      for(let i=0;i<this.tableData.length;i++){
        // 需要检查分配人数是否超出
        if(parseInt(this.tableData[i].groupAndNum)>this.tableData[i].totalNum){
          toast(this,`${this.tableData[i].deptName}分配人数不能大于科室总人数`);
          this.submitLoading = false;
          return;
        };
        this.tableData[i].groupAndNum=this.tableData[i].groupAndNum?this.tableData[i].groupAndNum:0;
        totalSignNum+=parseInt(this.tableData[i].groupAndNum);

        // 按人员分配后，再按科室分，不能小于已经按该科室下的人员分配的数量
        let num=0;
        for(let j=0;j<this.signupStaff.length;j++){
          if(this.tableData[i].deptId==this.signupStaff[j].deptId){
            num++;
          }
        }
        if(parseInt(this.tableData[i].groupAndNum)<num){
          toast(this,`${this.tableData[i].deptName}分配人数不能小于该科室已分配的人员数`);
          this.submitLoading = false;
          return;
        };
      }

      // 有分组的情况下
      if(this.signupInfo.groupId&&this.signupInfo.groupId!=""){ 
        if(totalSignNum>this.signupInfo.maxNum){
          toast(this,`分配总人数不能大于可报名人数:${this.signupInfo.allowNum}人`);
          this.submitLoading = false;
          return;
        }
      }else{
        if(totalSignNum>this.signupInfo.maxNum){
          toast(this,`分配总人数不能大于可报名人数:${this.signupInfo.allowNum}人`);
          this.submitLoading = false;
          return;
        }
      }


      let signInfo=[];
      let {groupId} =this.signupInfo;
      groupId=groupId&&groupId.indexOf('_')>=0?groupId.split('_')[0]:groupId;

      this.tableData.forEach(item => {
        let groupNum="";
        if(groupId&&groupId!=""){
          groupNum=item.groupAndNum
            ? `{'${groupId}':${item.groupAndNum}}`
            : `{'${groupId}':0}`
        }else{
          groupNum=item.groupAndNum?item.groupAndNum:0
        };
        
     
        let obj={
          deptName:item.deptName,
          deptId:item.deptId,
          groupAndNum:groupNum,
          unionId:this.loginInfo.unionId,
          unionName:this.loginInfo.unionName,
          activityId:this.activityId,
          groupId:groupId,
        };
        signInfo.push(obj);
      })
      let data={
        signInfo:JSON.stringify(signInfo),
        action: "signUpByDept",
        activityId: this.activityId,
        unionId: this.selectedGroupUnionId||this.loginInfo.unionId,
        groupId:groupId,
      };
      signUpByDept(data).then(res => {
        if(res.code == 200){
          let data={
            saveDept:true
          };
          this.submitLoading=false;
          this.$emit("goback",data);
        }else{
          toast(this,res.message, "error");
        }
      })
    },

    operationNumChange(v1, v2, index) {
      if (parseInt(v1) > parseInt(v2)) {
        this.tableData[index].welfareNum = this.tableData[index].totalNum;
        toast(this,"分配的人员不可大于总人数");
      }
    },


  }
};
</script>
<style lang="stylus" type="stylesheet/stylus">
  .sign-distribution{
    height:100vh;
    width:100vw;
    background:#fff; 
    .header{
      padding:10px;
      display:flex;
      justify-content:flex-start;
      align-items:center;
    }
    .signList{
      padding:0 10px;
      height: calc(100% - 80px - 60px);
      overflow-x: hidden;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
      .item{
        display:flex;
        justify-content:space-between;
        align-items:center;
        margin:10px 0;
        label{
          font-size:14px;
          width:160px;
        }
        // .input-block{
        //   display:flex;
        //   align-items:center;
        //   span{
        //     width:50px;
        //     font-size:14px;
        //   }
        //   .el-input{
        //     flex:1;
        //     width:120px;
        //   }
        // }
      }
    }

    .block{
      display:flex;
      align-items:center;
      justify-content:flex-start;
      padding:10px 0;
      border-bottom:1px solid #e1e1e1;
      &.header{
        color:#fff;
        background:#38c7c4;
        span:nth-child(1){
          padding-left:10px;     
        }
      }
      span{
        display:inline-block;
      }
      .el-input__inner{
        border: none;
      }
      .input-block{
        width:90px;
        border:none;
        outline:none;
        background:none;
        font-size:14px;
      }
      .name-block{
        flex:1;
        font-size:15px; 
      }
    }

    .el-radio-group{
      margin:10px 0 10px 30px;
      font-size:16px;
    }
    .cubeic-back{
      font-size:16px;
    }

    .el-radio__input.is-checked+.el-radio__label{
      color:#38c7c4;
    }
    .el-radio__input.is-checked .el-radio__inner{
      border-color: #38c7c4;
      background: #38c7c4;
    }
    .el-input.is-active .el-input__inner, .el-input__inner:focus {
      border-color: #38c7c4;
    }
    .footer-tip {
      height: 24px;
      background: #FF4B4B;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      text-align: center;
      line-height: 24px;
      margin-bottom: 10px;
    }
    .sino-welfare-footer .save-btn{
      line-height:0;
      color:#fff !important;
    }
  }
</style>